import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { AbsoluteSpinner, BackButton, Logo } from '../App/Components'
import { StyledScrollView } from '../App/Components/AppContainer'
import { Calendar } from '../Calendar/Calendar/Calendar'
import { useHistory, useParams } from '../Router'
import { useAppSelector } from '../store/hooks'
import { ServiceTitle } from '../Appointment/style'
import { SelectPersonForAllActivities } from '../Appointment/Components/SelectPersonForAllActivities/SelectPersonForAllActivities'
import { isSelectAPerson } from '../App/Util/selectPersonChecks/isSelectAPerson/isSelectAPerson'

export const AppointmentDate = () => {
  const { establishmentId } = useParams<{ [key: string]: string }>()
  const history = useHistory()
  const { t } = useTranslation()

  const { settingsState, appointment } = useAppSelector((state) => ({
    appointment: state.appointment,
    settingsState: state.settings,
  }))

  const flatCustomerActivities = useMemo(
    () => appointment.customers.map((customer) => customer.activities).flat(2),
    [appointment]
  )

  useEffect(() => {
    if (flatCustomerActivities.length === 0) {
      history.push(`/${establishmentId}/appointment`)
    }
  }, [flatCustomerActivities.length, history, establishmentId])

  if (typeof settingsState.values === 'undefined' || !appointment) {
    return <AbsoluteSpinner />
  }

  return (
    <StyledScrollView autoScroll>
      <Logo />
      <ServiceTitle fontcolor={settingsState.values.fontColor}>
        {t('Date')}
      </ServiceTitle>
      <BackButton customPath={`/${establishmentId}/appointment`} />
      <SelectPersonForAllActivities isPersonSelectable={isSelectAPerson(flatCustomerActivities)} />
      <Calendar settings={settingsState.values} />
    </StyledScrollView>
  )
}
